import { Component } from '@theme/component';

class SodStickyCta extends Component {
  #observer = null;

  #scrollController;

  #stickyBar = null;
  #frame = 0;

  connectedCallback() {
    super.connectedCallback();

    const section =
      document.getElementById(`shopify-section-${this.dataset.sectionId}`) ?? this.closest('.shopify-section');
    this.bar = section?.querySelector('sticky-add-to-cart');
    if (!this.bar || !this.dataset.label?.trim()) return;

    this.#apply();

    this.#observer = new MutationObserver(this.#apply);
    this.#observer.observe(this.bar, { childList: true, subtree: true, characterData: true });

    this.#stickyBar = this.bar.querySelector('[data-stuck]');
    if (this.#stickyBar) {
      this.#scrollController = new AbortController();
      const { signal } = this.#scrollController;

      for (const target of [window, document.querySelector('.page-wrapper')]) {
        target?.addEventListener('scroll', this.#onScroll, { passive: true, signal });
      }
      addEventListener('resize', this.#onScroll, { passive: true, signal });
      this.#sync();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.#scrollController?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #onScroll = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      this.#sync();
    });
  };

  #sync = () => {
    const buttons = document.querySelector('.buy-buttons-block');
    if (!buttons || !this.#stickyBar) return;

    const scrolledPast = buttons.getBoundingClientRect().bottom < 0;
    const footer = document.querySelector('footer') ?? document.querySelector('[class*="footer-group"]');
    const atFooter = footer ? footer.getBoundingClientRect().top < innerHeight : false;

    const stuck = scrolledPast && !atFooter;
    const now = stuck ? 'true' : 'false';
    if (this.#stickyBar.dataset.stuck !== now) this.#stickyBar.dataset.stuck = now;
  };

  #apply = () => {
    const button = this.bar?.querySelector('.sticky-add-to-cart__button');
    if (!button || button.disabled) return;

    const target = button.querySelector('.add-to-cart-text__content > span:first-child');
    const label = this.dataset.label?.trim();

    if (!target || !label || target.textContent.trim() === label) return;

    target.textContent = label;
  };
}

if (!customElements.get('sod-sticky-cta')) customElements.define('sod-sticky-cta', SodStickyCta);
